import { render, staticRenderFns } from "./OFileUpload.vue?vue&type=template&id=278758e0&scoped=true&"
import script from "./OFileUpload.vue?vue&type=script&lang=js&"
export * from "./OFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278758e0",
  null
  
)

export default component.exports